export default __webpack_public_path__ + "static/media/subject.8eec5e17.png";